<template>
  <div class="container">
    <div class="fullscreen-row">
      <div
        class="col-sm-12 mx-auto text-center section-title-wrapper splash-s splash-container d-flex"
        style="padding-top: 30px"
      >
        <h1 class="white h1-larger">QUALIFYING</h1>
      </div>
    </div>
    <div id="qualifierTextRow" class="row" v-if="render">
      <div class="col-md-6">
        <vm id="vm" class="mb-0 white lead p-info">
          {{ this.text.leftSide }}
        </vm>
      </div>
      <div class="col-md-6">
        <vm id="vm" class="mb-0 white lead p-info">
          {{ this.text.rightSide }}
        </vm>
      </div>
    </div>
    <div
      class="row"
      v-for="(event, index) in events"
      :key="index"
      data-aos="fade-left"
      data-aos-duration="1000"
    >
      <div
        class="col-sm-3 col-xs-12 d-flex align-items-center justify-content-center"
        :class="index % 2 ? 'col-bg-orange' : 'col-bg-orange-dark'"
      >
        <div class="event-date">
          <h1>{{ event.fields.eventTag }}</h1>
          <h3>{{ event.fields.eventMonat }}</h3>
        </div>
      </div>
      <div
        class="col-sm-6 col-xs-12 col-bg-dark d-flex align-items-center justify-content-left"
      >
        <div class="event-description">
          <h3>{{ event.fields.titel }}</h3>
          <p>{{ event.fields.untertitel }}</p>
        </div>
      </div>
      <div
        class="col-sm-3 col-xs-12 col-bg-dark d-flex align-items-center justify-content-center"
      >
        <a
          :href="event.fields.link"
          target="_blank"
          rel="noopener noreferrer"
          v-if="showButton(index) "
          >Anmelden</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import client from "../../utils/api.js";
import VueMarkdown from "vue-markdown";

export default {
  data() {
    return {
      currentDate: null,
      events: [],
      render: false,
      text: {
        leftSide: "",
        rightSide: "",
      },
    };
  },
  methods: {
    showButton(index) {
      if (index == 0 && this.currentDate < new Date(2020, 9, 13)) {
        return true;
      }
      if (
        index == 1 &&
        this.currentDate >= new Date(2020, 9, 13) &&
        this.currentDate < new Date(2020, 9, 18)
      ) {
        return true;
      }
      if (
        index == 2 &&
        this.currentDate >= new Date(2020, 9, 18) &&
        this.currentDate < new Date(2020, 9, 25)
      ) {
        return true;
      }
      if (
        index == 3 &&
        this.currentDate >= new Date(2020, 9, 25) &&
        this.currentDate < new Date(2020, 10, 1)
      ) {
        return true;
      }
    },
  },
  components: {
    vm: VueMarkdown,
  },
  created() {
    client
      .getEntries({ content_type: "event", order: "sys.createdAt" })
      .then((response) => {
        this.events = response.items;
      });

    client.getEntries({ content_type: "qualifierText" }).then((response) => {
      this.text.leftSide = response.items[0].fields.textLeftSide;
      this.text.rightSide = response.items[0].fields.textRightSide;
      this.render = true;
    });

    //Date check
    //JJJJ MM DD
    //Note: month 9 = October, 10 = November
    this.currentDate = new Date(); //use this
    // this.currentDate = new Date(2020, 9, 15) //use for testing
  },
};
</script>

<style scoped>
.container {
  width: 90%;
}
.row {
  min-height: 120px;
  margin: 15px 0;
  background-color: white;
}
.col-bg-orange {
  background-color: #eb6626;
}

.col-bg-orange-dark {
  background-color: #dd2207;
}
.col-bg-dark {
  background-color: black;
  opacity: 0.9;
}

a {
  border: 1px solid white;
  padding: 8px 20px;
  color: white;
}

a:hover {
  color: #eb6626;
  border-color: #eb6626;
}

@media screen and (max-width: 500px) {
  .container {
    margin: 50px auto;
  }
  a {
    margin: 15px 0;
  }
}

.event-date > h1,
h3 {
  color: white;
  text-align: center;
}

.event-description {
  margin-top: 15px;
}

.event-description > h3,
p {
  color: white;
  text-align: left;
}

.fullscreen-row {
  width: 100vw;
  position: relative;
  left: calc(-50vw + 50%);
}

.fullscreen-row:before,
.fullscreen-row:after {
  display: table;
  content: " ";
}

.fullscreen-row:after {
  clear: both;
}

#qualifierTextRow {
  background: transparent;
  margin-bottom: 50px;
}

.p-larger {
  font-size: 1.75em !important;
}
.white {
  color: white !important;
}
.h1-larger {
  font-size: 4.5em;
}

.splash-s {
  background-image: url(/static/img/splash_qualifier_red.png),
    url(/static/img/splash_qualifier_blue.png);
  background-position: 32% 70%, 95% 0%;
  background-repeat: no-repeat;
  min-height: 200px;
}

.splash-container {
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 600px) {
  .h1-larger {
    font-size: 3em;
  }
  .p-larger {
    font-size: 1.25em !important;
  }
  .splash-s {
    background-image: url(/static/img/splash_qualifier_red.png),
      url(/static/img/splash_qualifier_blue.png);
    background-position: 12% 55%, 96% 25% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 80px, 60px;
    min-height: 200px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1000px) {
  .h1-larger {
    font-size: 3em;
  }
  .p-larger {
    font-size: 1.25em !important;
  }
  .splash-s {
    background-image: url(/static/img/splash_qualifier_red.png),
      url(/static/img/splash_qualifier_blue.png);
    background-position: 30% 60%, 90% 25% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 95px, 80px;
    min-height: 200px;
  }
}

/*XR*/
@media screen and (width: 828px) and (height: 1792px) {
  .h1-larger {
    font-size: 4.5em !important;
  }
  .row > div > .p-larger {
    font-size: 1.9em !important;
  }
  .fullscreen-row > .splash-s {
    background-image: url(/static/img/splash_qualifier_red.png),
      url(/static/img/splash_qualifier_blue.png);
    background-position: 25% 60%, 90% 74% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 100px, 100px;
    min-height: 200px;
  }
}
</style>


